import { createContext } from "react";

import { IAuthContext } from "./types.ts";

export const AuthContext = createContext({} as IAuthContext);
